import { ISelectorOptions } from 'components/common'
import { BookingChargeType } from 'generated/graphql'

export const OtherChargeEntity = {
  MAX_DESCRIPTION_LENGTH: 200,
  MAX_NOMINAL_CODE_LENGTH: 8,
}

export const WEEKEND_DAYS = [0, 6]
export const WORK_START_HOUR = 6
export const WORK_END_HOUR = 18

export const BookingChargeDefaultsByType: Partial<
  Record<
    BookingChargeType,
    {
      name: string
      type: BookingChargeType
      quantity: number
      isDeleted: boolean
      isAutomatic: boolean
      rate?: number
    }
  >
> = {
  [BookingChargeType.OutOfHours]: {
    name: 'Out Of Hours',
    type: BookingChargeType.OutOfHours,
    quantity: 1,
    rate: 30,
    isDeleted: false,
    isAutomatic: true,
  },
  [BookingChargeType.SpecialZone]: {
    name: 'Special Zone',
    type: BookingChargeType.SpecialZone,
    quantity: 1,
    isDeleted: false,
    isAutomatic: true,
  },
  [BookingChargeType.Drop]: {
    name: 'Drop',
    type: BookingChargeType.Drop,
    quantity: 1,
    isDeleted: false,
    isAutomatic: true,
  },
  [BookingChargeType.WaitAndReturn]: {
    name: 'Wait and Return Fee',
    type: BookingChargeType.WaitAndReturn,
    quantity: 1,
    isDeleted: false,
    isAutomatic: true,
  },
}

// ToDo: remove Custom charge type from BA
export const BookingChargeTypeValues: ISelectorOptions = [
  { value: BookingChargeType.SpecialZone, label: 'Special Zone' },
  { value: BookingChargeType.Other, label: 'Other' },
]
